import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';

import { useArchetypeShare } from '../hooks/useArchetypeShare';

interface ArchetypeShareButtonProps {
  archetype: string;
  archetypeDescription?: string | null;
}

export const ArchetypeShareButton: React.FC<ArchetypeShareButtonProps> = ({ archetype, archetypeDescription }) => {
  const { share, isGenerating, hiddenCard } = useArchetypeShare({ archetype, archetypeDescription });

  return (
    <>
      {hiddenCard}
      <Button
        variant="outlined"
        size="small"
        startIcon={isGenerating ? <CircularProgress size={16} /> : <ShareRoundedIcon />}
        onClick={share}
        disabled={isGenerating}
      >
        {isGenerating ? 'Generating...' : 'Share'}
      </Button>
    </>
  );
};
